<app-modal-basic #modalRelatorio (closed)="destroyComponent()">
  <div class="app-modal-header">
    <h4 class="modal-title">Notas Fiscais Comunicação</h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Emissão</label>
          <div class="input-group">
            <app-data [calendarPosition]="'left'" formControlName="inicio"></app-data>
            <span class="input-group-addon">até</span>
            <app-data formControlName="fim"></app-data>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="form-group col-sm-12">
          <label>Formato</label>
          <div class="form-radio">
            <div class="radio radiofill radio-inline">
              <label>
                <input type="radio" formControlName="tipoImpressao" [value]="'pdf'">
                <i class="helper"></i>PDF
              </label>
            </div>
            <div class="radio radiofill radio-inline">
              <label>
                <input type="radio" formControlName="tipoImpressao" [value]="'xlsx'">
                <i class="helper"></i>Excel
              </label>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
        <i class="icofont icofont-print"> </i> Imprimir
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">

  </div>

</app-modal-basic>